import "babel-polyfill";
import "@/router/registerClassComponentHooks";
import vuetify from "@/plugins/vuetify";
import router from "@/router";
import Vue from "vue";
import App from "./App.vue";
import "@/registerServiceWorker";
// @ts-ignore
import VueYandexMetrika from "vue-yandex-metrika";


Vue.use(VueYandexMetrika, {
    id: 80163055,
    router: router,
    env: process.env.NODE_ENV,
    options: {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app');
